import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  Stack,
  Backdrop,
  CircularProgress,
  TextField
} from '@material-ui/core';

import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { baseUrl } from '../../utils/constants';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { useAccountingContext } from '../../context/accounting_context';
import { useSettingContext } from '../../context/setting_context';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'vouchernos', label: 'Voucher No', alignRight: true },
  { id: 'datalo', label: 'Journal Date #', alignRight: true },
  { id: 'detailss', label: 'Details', alignRight: false },
  { id: 'trande', label: 'Chq #/DO', alignRight: true },
  { id: 'controll', label: 'Control Acc', alignRight: true },
  { id: 'debita', label: 'Debit', alignRight: true },
  { id: 'credita', label: 'Credit', alignRight: true },
  { id: 'dd', label: 'Analysis Total', alignRight: true },
  { id: 'proc', label: 'Processed', alignRight: true },
  //   { id: 'rog' },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ProviderJournals() {
  const { providerId } = useSettingContext();
  const [dataList, setDataList] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();
  const classes = useStyles();
  const zeroAmount = 0;

  useEffect(() => {
    if (providerId > 0) {
      getJournals(providerId, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // if (providerId > 0) {
    //   getTransactions(providerId, 0);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providerId]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getJournals = () => {
    axios(
      `${baseUrl}/api/accounting/GetJournalsByAccountRef?accountRefId=${providerId}&cycleDate=0`
    ).then(
      (result) => {
        console.log('returned Journals Transactions info', result);
        setDataList(result.data);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const openView = (e) => {
    navigate(`/claims/claimsSelect/${e}`);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  const totalCredits = dataList.reduce(
    (previousValue, currentValue) => previousValue + currentValue.credit,
    0
  );

  const totalDebits = dataList.reduce(
    (previousValue, currentValue) => previousValue + currentValue.debit,
    0
  );
  console.log('total credit journal', totalCredits - totalDebits);
  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stack direction="row" alignItems="right" justifyContent="end" mt="10" pt="3">
        <TextField
          size="small"
          id="currsBalance"
          // label="Journal Total"
          // inputProps={{ style: { textAlign: 'right' } }}
          InputProps={{
            inputComponent: Controls.NumberDecimal,
            style: { textAlign: 'right' }
          }}
          value={totalCredits - totalDebits}
        />
      </Stack>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                // onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      refId,
                      voucherNo,
                      journalDate,
                      details,
                      chequeNo,
                      controlAcc,
                      debit,
                      credit,
                      processed,
                      controlAmount
                    } = row;
                    const isItemSelected = selected.indexOf(refId) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={refId}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="right">{voucherNo}</TableCell>
                        <TableCell align="right" component="th" scope="row" padding="none">
                          {moment(journalDate).isValid()
                            ? moment(journalDate).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell align="left">{details}</TableCell>
                        <TableCell align="right">{chequeNo}</TableCell>
                        <TableCell align="right">{controlAcc}</TableCell>
                        <TableCell align="right">{debit.toFixed(2)}</TableCell>
                        <TableCell align="right">{credit.toFixed(2)}</TableCell>
                        <TableCell align="right">{controlAmount.toFixed(2)}</TableCell>
                        <TableCell align="right">
                          {credit === controlAmount ? 'Yes' : 'No'}
                        </TableCell>
                        {/* <TableCell align="right">
                          <IconButton onClick={() => handleView({ row })}>
                            <VisibilityIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell> */}
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
